import * as TYPE from './actionTypes'

export const setMenuData = (menuData) => ({
  type: TYPE.SET_MENU_DATA,
  menuData,
})

export const resetMenuData = () => ({
  type: TYPE.RESET_MENU_DATA,
})
